/**
 * 奖池副行文案。
 *
 * `roundsAccumulating === 0` 时**整段不渲染**，包括前面的分隔点。
 *
 * 后端 `MilharStatusService.roundsAccumulating` 在 `cycle_start_round <= 0` 时返回 0，
 * 那是「本轮累积尚未开始」的哨兵，不是「累积了零期」。把哨兵当数字念出来，
 * pt-BR 会得到 `já são 0 rodadas acumulando` ——「已经积了 0 期」，语法和语义都是坏的。
 * 此刻池子就等于种子，没有可讲的故事，少说一句比说错一句好。
 */
export function poolRoundsLine(
  roundsAccumulating: number | null | undefined,
  template: string,
): string | null {
  if (typeof roundsAccumulating !== 'number') return null;
  if (!Number.isFinite(roundsAccumulating) || roundsAccumulating <= 0) return null;
  return template.replace('%n%', String(Math.floor(roundsAccumulating)));
}
